import { InventoryStateTypes, InventoryActionTypes } from "./Inventory.type";
import { InitPagedData, resetApiCallState } from "../Utils";

const INITIAL_STATE: InventoryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchAllQueried: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchAnalysis: resetApiCallState(InitPagedData),
  fetchStockCard: resetApiCallState([]),
};

const InventoryReducer = (
  state: InventoryStateTypes = INITIAL_STATE,
  action: any
): InventoryStateTypes => {
  switch (action.type) {
    case InventoryActionTypes.FETCH_ALL_INVENTORY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ALL_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY:
      return {
        ...state,
        fetchAllQueried: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_RESET:
      return {
        ...state,
        fetchAllQueried: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_FAILURE:
      return {
        ...state,
        fetchAllQueried: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ALL_QUERIED_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchAllQueried: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_ONE_INVENTORY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ONE_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ----------------------------

    case InventoryActionTypes.FETCH_ANALYSIS_INVENTORY:
      return {
        ...state,
        fetchAnalysis: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_ANALYSIS_INVENTORY_RESET:
      return {
        ...state,
        fetchAnalysis: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_ANALYSIS_INVENTORY_FAILURE:
      return {
        ...state,
        fetchAnalysis: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_ANALYSIS_INVENTORY_SUCCESS:
      return {
        ...state,
        fetchAnalysis: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case InventoryActionTypes.FETCH_INVENTORY_STOCK_CARD:
      return {
        ...state,
        fetchStockCard: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_RESET:
      return {
        ...state,
        fetchStockCard: resetApiCallState([]),
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_FAILURE:
      return {
        ...state,
        fetchStockCard: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InventoryActionTypes.FETCH_INVENTORY_STOCK_SUCCESS:
      return {
        ...state,
        fetchStockCard: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default InventoryReducer;
